import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './unsubscribe-basic.component.scss';

export class UnsubscribeBasic extends Base {

	containerUnsubscribe :any;
	containerNotValid: any;
	containerChanged: any;
	containerCancelled: any;
	containerLoader: any;

	btnUnsubscribe: any;

	constructor(element: Element){

		super(element);

	}

	init(){
		
		this.containerUnsubscribe = this.element.querySelector('.unsubscribe-basic__container--change');
		this.containerNotValid = this.element.querySelector('.unsubscribe-basic__container--notvalid');
		this.containerCancelled = this.element.querySelector('.unsubscribe-basic__container--cancelled');
		this.containerLoader = this.element.querySelector('.unsubscribe-basic__container--loader');
		
		this.btnUnsubscribe = this.element.querySelector('.unsubscribe-basic__button--unsubscribe');

		TooltipsService.initTooltips();

	}

	bindEvents() {

		this.btnUnsubscribe.addEventListener('click', (event)=>{

			const element = event.target;
			const form = element.closest('form');
			this.unsubscribe(form);

		});

	}

	unsubscribe(form: any) {

		this.containerUnsubscribe.classList.remove('d-block');
		this.containerNotValid.classList.remove('d-block');
		this.containerCancelled.classList.remove('d-block');
		this.containerLoader.classList.add('d-block');

		let operation: any = "unsubscribe";	
		let formId: any = form.querySelector('input.js-unsubscribe-formid').value;	
		let subId: any = form.querySelector('input.js-unsubscribe-subid').value;
		let siteName: any = form.querySelector('input.js-unsubscribe-sitename').value;	

		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (formId) {
			postData += 'formId=' + formId + '&';
		}
		if (subId) {
			postData += 'subId=' + subId + '&';
		}
		if (siteName) {
			postData += 'site=' + siteName + '&';
		}

		let analyticsService = new AnalyticsService();
		let url = "/services/NewsLetterSubscription.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {

			this.containerLoader.classList.remove('d-block');

			if(response.data.result) {

				let result = response.data.result;

				if(result.indexOf('unsubscribed') !== -1) {
					
					if(localStorage.getItem('sbgNewsletterSubscriberId')){
						localStorage.removeItem('sbgNewsletterSubscriberId');
					}
					analyticsService.dtmFormComplete('complete', response.data.subscriberId);
					this.containerUnsubscribe.classList.remove('d-block');
					this.containerCancelled.classList.add('d-block');

				}else{

					this.containerUnsubscribe.classList.remove('d-block');
					this.containerNotValid.classList.add('d-block');

				}

			}else{

				this.containerUnsubscribe.classList.remove('d-block');
				this.containerNotValid.classList.add('d-block');
				
			}

		}).catch(error => {

			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			console.log(error);
			this.containerLoader.classList.remove('d-block');
			this.containerUnsubscribe.classList.remove('d-block');
			this.containerNotValid.classList.add('d-block');

		});

	}

}


// WEBPACK FOOTER //
// ./components/unsubscribe-basic/unsubscribe-basic.component.ts